import React from 'react'
import { Link } from 'react-router-dom'
import style from './style.module.scss'

class AppBreadCrumbs extends React.Component {
  render() {
    const { params, title } = this.props
    return (
      <div className={style.breadcrumbsMain}>
        <div className={style.breadcrumbs}>
          {params.map((item, i) => (
            <span key={item.title !== undefined ? item.title : i}>
              {item.url && (
                <span className={style.titleName}>
                  <Link to={item.url}>{item.title}</Link>
                </span>
              )}
              {!item.url && <span className={style.currentPageBreadcrumb}>{item.title}</span>}
              {params.length !== i + 1 && <span className={style.divider}>&#62; </span>}
            </span>
          ))}
        </div>
        {title && <div className={style.itemTitle}>{title}</div>}
      </div>
    )
  }
}

export default AppBreadCrumbs
